import React, { Component } from "react";
import { connect } from "react-redux";
import _get from "lodash/get";

import { formatDate } from "@lib/helpers";

import { apiCall, addAlert } from "@store/app/actions";
import {
  upvoteReviewApi,
  downvoteReviewApi,
  upvoteQuestionApi,
  downvoteQuestionApi,
} from "@lib/api/index";

class CommentItem extends Component {
  constructor() {
    super();
    this.state = {
      upvoteChecked: false,
      downvoteChecked: false,
    };
    this.upvote = this.upvote.bind(this);
    this.downvote = this.downvote.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
  }

  componentDidMount() {
    if (this.props.user.customer !== null) {
      this.setState({
        upvoteChecked: this.props.comment.community.customers_upvoting.includes(
          this.props.user.customer.id
        ),
        downvoteChecked:
          this.props.comment.community.customers_downvoting.includes(
            this.props.user.customer.id
          ),
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.customer !== this.props.user.customer) {
      if (this.props.user.customer !== null) {
        this.setState({
          upvoteChecked:
            this.props.comment.community.customers_upvoting.includes(
              this.props.user.customer.id
            ),
          downvoteChecked:
            this.props.comment.community.customers_downvoting.includes(
              this.props.user.customer.id
            ),
        });
      }
    }
  }

  onChangeValue(event) {
    if (event.target.value === "da") {
      this.upvote(this.props.comment._id, event);
    } else {
      this.downvote(this.props.comment._id, event);
    }
  }

  upvote = async (id, event) => {
    event.persist();
    if (this.props.user.isLoggedIn) {
      // first check for downvote decrement
      if (
        this.props.comment.community.customers_downvoting.includes(
          this.props.user.customer.id
        )
      ) {
        await this.props.apiCall({
          spinner: true,
          alert: true,
          apiCall:
            this.props.type === "reviews"
              ? downvoteReviewApi
              : downvoteQuestionApi,
          apiArgs: [
            {
              id: id,
              communityCustomerId: this.props.user.customer.id,
              downVotes: true,
            },
          ],
          returnResponse: false,
        });
      }
      // then increment the upvote
      let res = await this.props.apiCall({
        spinner: true,
        alert: true,
        apiCall:
          this.props.type === "reviews" ? upvoteReviewApi : upvoteQuestionApi,
        apiArgs: [{ id: id, communityCustomerId: this.props.user.customer.id }],
        returnResponse: true,
        postSuccess: () => {
          this.setState({
            upvoteChecked: true,
            downvoteChecked: false,
          });
          this.props.addAlert({
            message: `Votul tau a fost inregistrat. Iti multumim.`,
            variant: "success",
          });
        },
      });

      // set information is state in order to have proper display of data
      this.setState({
        customers_downvoting: res.data.community.customers_downvoting,
        customers_upvoting: res.data.community.customers_upvoting,
      });
    } else {
      this.props.addAlert({
        message: `Trebuie sa fii autentificat.`,
        variant: "error",
      });
    }
  };

  downvote = async (id, event) => {
    event.persist();
    if (this.props.user.isLoggedIn) {
      // first check for upvote decrement
      if (
        this.props.comment.community.customers_upvoting.includes(
          this.props.user.customer.id
        )
      ) {
        await this.props.apiCall({
          spinner: true,
          alert: true,
          apiCall:
            this.props.type === "reviews" ? upvoteReviewApi : upvoteQuestionApi,
          apiArgs: [
            {
              id: id,
              communityCustomerId: this.props.user.customer.id,
              downVotes: true,
            },
          ],
          returnResponse: false,
        });
      }
      let res = await this.props.apiCall({
        spinner: true,
        alert: true,
        apiCall:
          this.props.type === "reviews"
            ? downvoteReviewApi
            : downvoteQuestionApi,
        apiArgs: [{ id: id, communityCustomerId: this.props.user.customer.id }],
        returnResponse: true,
        postSuccess: () => {
          this.setState({
            upvoteChecked: false,
            downvoteChecked: true,
          });
          this.props.addAlert({
            message: `Votul tau a fost inregistrat. Iti multumim.`,
            variant: "success",
          });
        },
      });
      // set information is state in order to have proper display of data
      this.setState({
        customers_downvoting: res.data.community.customers_downvoting,
        customers_upvoting: res.data.community.customers_upvoting,
      });
    } else {
      this.props.addAlert({
        message: `Trebuie sa fii autentificat.`,
        variant: "error",
      });
    }
  };

  render() {
    const { upvoted, downvoted } = this.state;
    const { index, comment, type } = this.props;
    const name = "helpful-" + comment._id;

    return (
      <li
        className={`py-4 ${index === 0 ? "" : "border-t border-gray-lighter"}`}
        key={comment._id}
      >
        <div className="md:flex items-center">
          <div className="text-black font-bold">{comment.customer.name}</div>
          <div className="hidden md:block h-1 w-1 bg-gray-light rounded-full mx-2"></div>
          <div>{formatDate(comment.date)}</div>
          {comment.fromMerchandiser && (
            <div className="md:ml-4">
              <div
                className="inline-block text-white text-xs uppercase leading-none rounded-sm p-1"
                style={{ backgroundColor: "#51C1ED" }}
              >
                Reprezentant oficial
              </div>
            </div>
          )}
        </div>
        <div className="break-words whitespace-pre-wrap">
          <p className="text-gray-dark">{comment.body}</p>
        </div>
        {type !== "reviews" && (
          <div className="flex items-center flex-wrap mt-6">
            <label
              htmlFor={name + "da"}
              className="Form-label inline-block mr-4 w-full sm:w-auto"
            >
              Ti-a fost de ajutor?
            </label>
            <label className="Form-checkbox inline-flex items-center mr-6">
              <input
                name={name + "da"}
                type="radio"
                value="da"
                className="checkbox-input opacity-0 w-0 h-0"
                onChange={this.onChangeValue}
                checked={this.state.upvoteChecked}
              />
              <span className="checkbox-control is-radio flex-none inline-flex w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="10" height="10" rx="5" fill="#319D10" />
                </svg>
              </span>
              <span className="Form-label inline-block">
                Da ({_get(comment, "community.upvotes", 0) + (upvoted ? 1 : 0)})
              </span>
            </label>

            <label className="Form-checkbox inline-flex items-center mr-6">
              <input
                name={name + "nu"}
                type="radio"
                value="nu"
                className="checkbox-input opacity-0 w-0 h-0"
                onChange={this.onChangeValue}
                checked={this.state.downvoteChecked}
              />
              <span className="checkbox-control is-radio flex-none inline-flex w-5 h-5 p-1 mr-2 border-gray-light border rounded-full bg-white">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="10" height="10" rx="5" fill="#319D10" />
                </svg>
              </span>
              <span className="Form-label inline-block">
                Nu (
                {_get(comment, "community.downvotes", 0) + (downvoted ? 1 : 0)})
              </span>
            </label>
          </div>
        )}
      </li>
    );
  }
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  {
    apiCall,
    addAlert,
  }
)(CommentItem);
